<div class="content" role="main" *ngIf="ready">
  <style *ngFor="let s of styles" [innerHTML]="s"></style>
  <div class="card-container">    
  <mat-card class="example-card">
    <div class="header" *ngIf="!context.getOption('hide-header')">
      <img class="logo mb" *ngIf="context.logo != null" [src]="context.logo">
      <div class="mat-title" [innerHtml]="context.getText('questionnaire-title', 'Questionnaire de pré-inscription')"></div>
      <div class="mat-subtitle" [innerHtml]="context.getText('questionnaire-subtitle', 'Complétez ce questionnaire afin de transmettre votre demande à la structure')"></div>
    </div>
    <mat-card-content>      
        <div *ngIf="context.singlePage">
          <form #globalForm="ngForm" novalidate>
          <div *ngFor="let s of context.sections">            
            <div *ngIf="s == 'enfant'"  class="section">
              <h4 class="mat-title">{{ context.getText('step-enfant-title', 'Enfant') }}</h4>
              <app-children [context]="context" [enfant]="demande.enfant"></app-children>
            </div>
            <div *ngIf="s == 'parent-1'"  class="section">
              <h4 class="mat-title">{{ context.getText('step-parent-1-title', 'Parent 1') }}</h4>
              <app-parent [context]="context" [parent]="demande.parent1" rank="1"></app-parent>
            </div>
            <div *ngIf="!context.getOption('hide-parent-2') && !demande.parent1.isole && s == 'parent-2'"  class="section"> 
              <h4 class="mat-title">{{ context.getText('step-parent-2-title', 'Parent 2') }}</h4>
              <app-parent [context]="context" [parent]="demande.parent2" rank="2"></app-parent>
            </div>
            <div *ngIf="s == 'demande'"  class="section">
              <h4 class="mat-title">{{ context.getText('step-demande-title', 'Détails de la demande') }}</h4>
              <app-demande [context]="context" [demande]="demande"></app-demande>
            </div>
            <div *ngIf="!context.getOption('hide-planning') && s == 'planning'"  class="section">
              <h4 class="mat-title">{{ context.getText('step-planning-title', 'Jours de garde souhaités') }}</h4>
              <app-planning [context]="context" [planning]="demande.planning"></app-planning>
            </div>
            <div *ngIf="s == 'complements'"  class="section">
              <h4 class="mat-title">{{ context.getText('step-complements-title', 'Compléments') }}</h4>
              <app-complements [context]="context" [demande]="demande"></app-complements>
            </div>
            <div *ngIf="s == 'finalisation'"  class="section">
              <h4 class="mat-title">{{ context.getText('step-finalisation-title', 'Finalisation') }}</h4>
              <app-finalisation [context]="context" [form]="globalForm.valid" [demande]="demande" (onFinish)="send()"></app-finalisation>
            </div>
          </div>
        </form>
        </div>  

        <mat-vertical-stepper #verticalStepper [linear]="!context.test" *ngIf="!context.singlePage">

          <ng-template matStepperIcon="parent">
            <mat-icon>supervisor_account</mat-icon>
          </ng-template>
          <ng-template matStepperIcon="children">
            <mat-icon>face</mat-icon>
          </ng-template>
          <ng-template matStepperIcon="demand">
            <mat-icon>description</mat-icon>
          </ng-template>
          <ng-template matStepperIcon="planning">
            <mat-icon>schedule</mat-icon>
          </ng-template>
          <ng-template matStepperIcon="complements">
            <mat-icon>search</mat-icon>
          </ng-template>
          <ng-template matStepperIcon="finalisation">
            <mat-icon>thumb_up</mat-icon>
          </ng-template>
          
          <div *ngFor="let s of context.sections">
            {{ s }}
          <form #enfant="ngForm" novalidate *ngIf="s == 'enfant'">
            <mat-step [completed]="enfant.valid" state="children">
              <ng-template matStepLabel>{{ context.getText('step-enfant-title', 'Enfant') }}</ng-template>
              <app-children [context]="context" [enfant]="demande.enfant"></app-children>
            </mat-step>    
          </form>

          <form #parent1="ngForm" novalidate *ngIf="s == 'parent-1'">
            <mat-step [completed]="parent1.valid" state="parent">
              <ng-template matStepLabel>{{ context.getText('step-parent-1-title', 'Parent 1') }}</ng-template>
              <app-parent [context]="context" [parent]="demande.parent1" rank="1"></app-parent>
            </mat-step>    
          </form>

          <form #parent2="ngForm" novalidate *ngIf="!context.getOption('hide-parent-2') && !demande.parent1.isole && s == 'parent-2'">
            <mat-step [completed]="parent2.valid" state="parent">
              <ng-template matStepLabel>{{ context.getText('step-parent-2-title', 'Parent 2') }}</ng-template>
              <app-parent [context]="context" [parent]="demande.parent2" rank="2"></app-parent>
            </mat-step>    
          </form>

          <form #demand="ngForm" novalidate *ngIf="s == 'demande'">
            <mat-step [completed]="demand.valid && hasSelectedTarget()" state="demand">
              <ng-template matStepLabel>{{ context.getText('step-demande-title', 'Détails de la demande') }}</ng-template>
              <app-demande [context]="context" [demande]="demande"></app-demande>
            </mat-step>    
          </form>

          <form #planning="ngForm" novalidate *ngIf="!context.getOption('hide-planning') && s == 'planning'">
            <mat-step [completed]="planning.valid && isHorairesValid()" state="planning">
              <ng-template matStepLabel>{{ context.getText('step-planning-title', 'Jours de garde souhaités') }}</ng-template>
              <app-planning [context]="context" [planning]="demande.planning"></app-planning>
            </mat-step>    
          </form>

          <form #complements="ngForm" novalidate *ngIf="s == 'complements'">
            <mat-step [completed]="complements.valid" state="complements">
              <ng-template matStepLabel>{{ context.getText('step-complements-title', 'Compléments') }}</ng-template>
              <app-complements [context]="context" [demande]="demande"></app-complements>
            </mat-step>    
          </form>

          <form #finalisation="ngForm" novalidate *ngIf="s == 'finalisation'">
            <mat-step [completed]="finalisation.valid" state="finalisation">
              <ng-template matStepLabel>{{ context.getText('step-finalisation-title', 'Finalisation') }}</ng-template>
              <app-finalisation [context]="context" [form]="true" [demande]="demande" (onFinish)="send()"></app-finalisation>
            </mat-step>    
          </form>
        </div>
        </mat-vertical-stepper>        
    </mat-card-content>
  </mat-card>
  </div>
</div>
